"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const antd_1 = require("antd");
const react_facebook_login_1 = __importDefault(require("react-facebook-login"));
const react_google_login_1 = require("react-google-login");
require("./Register.scss");
const response_codes_1 = require("../../../assets/constants/response_codes");
const constants_1 = require("../../../assets/constants/constants");
const strings_1 = require("../../../assets/strings/strings");
const message_utils_1 = __importDefault(require("../../../utils/message_utils"));
const users_1 = require("../../../utils/users");
const auth_requests_1 = require("../../../dataSource/auth_requests");
const RoutesPaths_1 = require("../../../routes/RoutesPaths");
const AccessWrapper_1 = __importDefault(require("../accessWrapper/AccessWrapper"));
const format_1 = require("../../../utils/format");
const countriesArray_1 = require("../../../assets/constants/countriesArray");
const google_icon_webp_1 = __importDefault(require("../../../assets/images/google-icon.webp"));
const Telephone_1 = __importDefault(require("../../../components/telephone/Telephone"));
const useHubspot_1 = __importDefault(require("../../../utils/useHubspot"));
const PerfilStyles_1 = require("../../accountInfo/perfil/PerfilStyles");
const user_requests_1 = require("../../../dataSource/user_requests");
const helpers_1 = require("../../../utils/helpers");
const { Option } = antd_1.Select;
const initialData = {
    firstNameField: '',
    lastNameField: '',
    ddiField: '55',
    telephoneField: '',
    emailField: '',
    passwordField: '',
    confirmPasswordField: '',
    countryField: 'BRA',
};
const Register = () => {
    const history = (0, react_router_dom_1.useHistory)();
    const [formRegister] = antd_1.Form.useForm();
    const [isLoading, setLoading] = (0, react_1.useState)(false);
    const [disabledGoogle, setDisabledGoogle] = (0, react_1.useState)(false);
    const [registerData, setRegisterData] = (0, react_1.useState)(null);
    const showModalTermsRef = react_1.default.useRef(null);
    const { dispatch } = (0, useHubspot_1.default)();
    (0, react_1.useEffect)(() => {
        if ((0, users_1.checkUserIsAuth)()) {
            history.push(RoutesPaths_1.routesPaths.root);
        }
    }, []);
    const hubspotFormBuilder = (response, formName) => {
        const { firstName, lastName, email } = response.currentUser;
        dispatch({
            fields: [
                { name: 'email', value: email },
                { name: 'firstname', value: firstName },
                { name: 'lastname', value: lastName },
            ],
            context: {
                pageName: formName,
                pageUri: RoutesPaths_1.routesPaths.register,
                hutk: '',
            },
        });
    };
    const registerHubspotLead = (0, react_1.useCallback)(({ email, country, firstName, lastName, ddi, telephone }) => {
        dispatch({
            fields: [
                { name: 'email', value: email },
                { name: 'country', value: country },
                { name: 'firstname', value: firstName },
                { name: 'lastname', value: lastName },
                { name: 'mobilephone', value: `${ddi}${telephone}` },
            ],
            context: {
                pageName: 'Cadastro',
                pageUri: RoutesPaths_1.routesPaths.register,
                hutk: '',
            },
        });
    }, [dispatch]);
    const handleSubmit = (0, react_1.useCallback)(() => __awaiter(void 0, void 0, void 0, function* () {
        const firstName = formRegister.getFieldValue('firstNameField');
        const lastName = formRegister.getFieldValue('lastNameField');
        const ddi = formRegister.getFieldValue('ddiField').replace(/\D/g, '');
        const telephone = formRegister.getFieldValue('telephoneField').replace(/\D/g, '');
        const email = formRegister.getFieldValue('emailField');
        const password = formRegister.getFieldValue('passwordField');
        const country = formRegister.getFieldValue('countryField');
        const params = {
            firstName,
            lastName,
            email,
            ddi,
            telephone,
            password,
            country,
        };
        setRegisterData(params);
    }), [formRegister]);
    const handleRegisterResponse = (0, react_1.useCallback)((response, formName = null) => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b, _c;
        setLoading(false);
        setRegisterData(null);
        if (response.code === response_codes_1.RegisterCodes.success || response.code === response_codes_1.LoginCodes.success) {
            (0, users_1.saveLoginUserData)(response.token, response.permissions, response.currentUser);
            const { email } = response.currentUser;
            if (response.code === response_codes_1.RegisterCodes.success) {
                message_utils_1.default.success({
                    message: strings_1.RegisterMessages.successfulRegistration,
                    description: `${strings_1.RegisterMessages.emailSentTo1of2} ${email} ${strings_1.RegisterMessages.emailSentTo2of2} `,
                });
            }
            // retorna para a última página caso exista no storage
            const lastPage = (0, users_1.getLastPageBeforeLogin)();
            const politics = {
                allowStore: formRegister.getFieldValue('acceptStoreData'),
                emailOffers: false,
            };
            formName && hubspotFormBuilder(response, formName);
            yield (0, user_requests_1.editMyPolitics)(politics);
            if (lastPage) {
                history.push(lastPage);
            }
            else {
                history.push(RoutesPaths_1.routesPaths.root);
            }
        }
        else if (response.isError) {
            switch (response.code) {
                case response_codes_1.RegisterCodes.error.EMAIl_ALREADY_IN_USE:
                    message_utils_1.default.error({
                        message: strings_1.RegisterMessages.emailErrorWhileSignUp,
                        description: strings_1.RegisterMessages.emailAlreadyInUse,
                    });
                    (_a = document.querySelector('#emailField')) === null || _a === void 0 ? void 0 : _a.focus();
                    break;
                case response_codes_1.RegisterCodes.error.FACEBOOK_ALREADY_IN_USE:
                    message_utils_1.default.error({
                        message: strings_1.RegisterMessages.facebookErrorWhileSignUp,
                        description: strings_1.RegisterMessages.facebookAlreadyInUse,
                    });
                    (_b = document.querySelector('#emailField')) === null || _b === void 0 ? void 0 : _b.focus();
                    break;
                case response_codes_1.RegisterCodes.error.GOOGLE_ALREADY_IN_USE:
                    message_utils_1.default.error({
                        message: strings_1.RegisterMessages.googleErrorWhileSignUp,
                        description: strings_1.RegisterMessages.googleAlreadyInUse,
                    });
                    (_c = document.querySelector('#emailField')) === null || _c === void 0 ? void 0 : _c.focus();
                    break;
                default:
                    message_utils_1.default.error({
                        message: strings_1.RegisterMessages.genericMessageError,
                        description: strings_1.RegisterMessages.genericError,
                    });
                    break;
            }
        }
    }), [history]);
    const getCountryName = (0, react_1.useCallback)((name) => {
        const country = countriesArray_1.COUNTRIES.find(v => v.sigla3 === name);
        if (country) {
            return country.nome;
        }
        return '';
    }, []);
    const handleRequest = (0, react_1.useCallback)(() => __awaiter(void 0, void 0, void 0, function* () {
        setLoading(true);
        if (registerData) {
            const params = {
                firstName: registerData.firstName,
                lastName: registerData.lastName,
                email: registerData.email,
                telephone: `${registerData.ddi}#${registerData.telephone}`,
                password: registerData.password,
                country: registerData.country,
            };
            const checkboxValidate = new Promise((resolve, reject) => {
                const guestFields = ['acceptStoreData', 'requiredCheckbox'];
                const someNotChecked = guestFields.some(field => !formRegister.getFieldValue(field));
                if (someNotChecked)
                    formRegister
                        .validateFields()
                        .then(() => {
                        resolve(true);
                    })
                        .catch(error => reject(error));
                else
                    resolve(true);
            });
            checkboxValidate.then(() => __awaiter(void 0, void 0, void 0, function* () {
                const response = yield (0, auth_requests_1.userSignUp)(params);
                registerHubspotLead(registerData);
                handleRegisterResponse(response);
            }));
        }
    }), [registerData, handleRegisterResponse]);
    const responseFacebook = (0, react_1.useCallback)((facebookResponse) => __awaiter(void 0, void 0, void 0, function* () {
        if ('accessToken' in facebookResponse) {
            const bookingId = (0, helpers_1.decrypty)(localStorage.getItem(constants_1.LOCAL_STORAGE.bookingId));
            const response = yield (0, auth_requests_1.userAuthenticateWithFacebook)({
                accessToken: facebookResponse.accessToken,
                bookingId,
            });
            handleRegisterResponse(response, 'facebookForm');
        }
        else {
            message_utils_1.default.error({
                message: strings_1.RegisterMessages.facebookAuthenticationError,
            });
        }
    }), [handleRegisterResponse]);
    const responseGoogle = (0, react_1.useCallback)((googleResponse) => __awaiter(void 0, void 0, void 0, function* () {
        if ('accessToken' in googleResponse) {
            const bookingId = (0, helpers_1.decrypty)(localStorage.getItem(constants_1.LOCAL_STORAGE.bookingId));
            const response = yield (0, auth_requests_1.userAuthenticateWithGoogle)({
                accessToken: googleResponse.tokenObj.id_token,
                bookingId,
            });
            handleRegisterResponse(response, 'googleForm');
        }
        else {
            message_utils_1.default.error({
                message: strings_1.RegisterMessages.googleAuthenticationError,
            });
        }
    }), [handleRegisterResponse]);
    const responseFailureGoogle = (0, react_1.useCallback)((googleResponse) => __awaiter(void 0, void 0, void 0, function* () {
        if (googleResponse.error == 'idpiframe_initialization_failed') {
            message_utils_1.default.error({
                message: 'Para cadastrar com o Google é necessário desbloquear cookies de terceiros nas configurações do navegador.',
            });
            setDisabledGoogle(true);
        }
        else {
            message_utils_1.default.error({
                message: strings_1.RegisterMessages.googleAuthenticationError,
            });
        }
    }), [handleRegisterResponse]);
    (0, react_1.useEffect)(() => {
        document.title = '360 Suítes - Registrar';
    }, []);
    return (react_1.default.createElement("div", { className: "Register" },
        react_1.default.createElement(AccessWrapper_1.default, { ref: showModalTermsRef },
            react_1.default.createElement("div", { className: "form-container" },
                react_1.default.createElement("div", { className: "register-header" },
                    react_1.default.createElement("span", null, "Crie"),
                    ' ',
                    "sua conta no",
                    react_1.default.createElement("span", { className: "name" }, " 360 Su\u00EDtes")),
                react_1.default.createElement(react_facebook_login_1.default, { appId: constants_1.FACEBOOK_ID, autoLoad: false, fields: "name,email,picture", callback: responseFacebook, icon: "fa-facebook", textButton: "Cadastrar com Facebook", cssClass: "btn-social-register", isMobile: false }),
                react_1.default.createElement(react_google_login_1.GoogleLogin, { clientId: constants_1.GOOGLE_ID, buttonText: "Login", onSuccess: responseGoogle, onFailure: responseFailureGoogle, cookiePolicy: "single_host_origin", disabled: disabledGoogle, render: renderProps => (react_1.default.createElement(antd_1.Tooltip, { title: disabledGoogle
                            ? 'Para cadastrar com o Google é necessário desbloquear cookies de terceiros nas configurações do navegador.'
                            : '' },
                        react_1.default.createElement(antd_1.Button, { className: `btn-social-register ${!disabledGoogle ? 'btn-social-register-active' : 'btn-social-register-disabled'}`, onClick: renderProps.onClick, disabled: disabledGoogle },
                            react_1.default.createElement("img", { src: google_icon_webp_1.default, className: "social-icon", alt: "Google_Register" }),
                            "Cadastrar com",
                            react_1.default.createElement("span", { className: "media-name" }, " Google ")))) }),
                react_1.default.createElement("div", { className: "or-sep" },
                    react_1.default.createElement("div", { className: "line-through" }),
                    react_1.default.createElement("div", { className: "or-text" }, "ou")),
                react_1.default.createElement(antd_1.Form, { name: "cadastro", form: formRegister, className: "register-form", onFinish: () => handleSubmit(), initialValues: initialData, noValidate: true },
                    react_1.default.createElement("div", { className: "half-fields-container" },
                        react_1.default.createElement("div", { className: "field-container-half" },
                            react_1.default.createElement(antd_1.Form.Item, { label: "firstname", name: "firstNameField", rules: [
                                    {
                                        required: true,
                                        message: strings_1.RegisterMessages.validationRequired,
                                    },
                                    {
                                        max: 200,
                                        message: strings_1.RegisterMessages.validationCharactersMaximum200,
                                    },
                                ] },
                                react_1.default.createElement(antd_1.Input, { placeholder: "Nome", className: "InputField" }))),
                        react_1.default.createElement("div", { className: "field-container-half" },
                            react_1.default.createElement(antd_1.Form.Item, { label: "lastname", name: "lastNameField", rules: [
                                    {
                                        required: true,
                                        message: strings_1.RegisterMessages.validationRequired,
                                    },
                                    {
                                        max: 200,
                                        message: strings_1.RegisterMessages.validationCharactersMaximum200,
                                    },
                                ] },
                                react_1.default.createElement(antd_1.Input, { placeholder: "Sobrenome", className: "InputField" }))),
                        react_1.default.createElement("div", { className: "field-container-half" },
                            react_1.default.createElement(Telephone_1.default, { form: formRegister, required: true, ddiFieldName: "ddiField", ddiFormItemProps: {
                                    initialValue: '55',
                                    name: 'ddiField',
                                }, phoneFieldName: "telephoneField", phoneFormItemProps: {
                                    label: 'mobilephone',
                                    name: 'telephoneField',
                                }, phoneInputProps: {
                                    placeholder: 'Celular',
                                } })),
                        react_1.default.createElement("div", { className: "field-container-half" },
                            react_1.default.createElement(antd_1.Form.Item, { label: "E-mail", name: "emailField", rules: [
                                    {
                                        required: true,
                                        message: strings_1.FieldsMessages.email.insertYourEmail,
                                    },
                                    {
                                        type: 'email',
                                        message: strings_1.FieldsMessages.email.invalidEmailFormat,
                                    },
                                    {
                                        pattern: /^[a-z,A-z,0-9,@,.,_,-]+$/,
                                        message: strings_1.FieldsMessages.email.dontUseSpecialCharacters,
                                    },
                                ] },
                                react_1.default.createElement(antd_1.Input, { id: "emailField", className: "InputField", type: "email", placeholder: "E-mail" }))),
                        react_1.default.createElement("div", { className: "field-container-half" },
                            react_1.default.createElement(antd_1.Form.Item, { name: "passwordField", label: "", rules: [
                                    {
                                        required: true,
                                        message: strings_1.RegisterMessages.validationRequired,
                                    },
                                    {
                                        min: 6,
                                        message: strings_1.RegisterMessages.validationCharactersMinimum6,
                                    },
                                ] },
                                react_1.default.createElement(antd_1.Input.Password, { placeholder: "Senha", className: "InputField" }))),
                        react_1.default.createElement("div", { className: "field-container-half" },
                            react_1.default.createElement(antd_1.Form.Item, { name: "confirmPasswordField", label: "", dependencies: ['passwordField'], rules: [
                                    {
                                        required: true,
                                        message: strings_1.RegisterMessages.validationRequired,
                                    },
                                    ({ getFieldValue }) => ({
                                        validator(rule, value) {
                                            if (!value || getFieldValue('passwordField') === value) {
                                                return Promise.resolve();
                                            }
                                            return Promise.reject(strings_1.RegisterMessages.validationConfirmPassword);
                                        },
                                    }),
                                ] },
                                react_1.default.createElement(antd_1.Input.Password, { placeholder: "Confirmar Senha", className: "InputField" })))),
                    react_1.default.createElement(antd_1.Form.Item, { label: "country", name: "countryField", rules: [
                            {
                                required: true,
                                message: strings_1.RegisterMessages.validationPleaseSelectAnOption,
                            },
                        ] },
                        react_1.default.createElement(antd_1.Select, { className: "select-field", placeholder: "Selecione o pa\u00EDs" }, countriesArray_1.COUNTRIES.map(v => (react_1.default.createElement(Option, { key: v.sigla3, value: v.sigla3 }, v.nome))))),
                    react_1.default.createElement(antd_1.Form.Item, { className: "checkboxLabel", valuePropName: "checked", name: "acceptStoreData", rules: [
                            {
                                required: true,
                                validator: (_, value) => value ? Promise.resolve() : Promise.reject(Error('Permita que a 360 processe seus dados')),
                            },
                        ] },
                        react_1.default.createElement(PerfilStyles_1.CheckboxStyled, null, "Eu permito que a 360 Su\u00EDtes armazene e processe meus dados pessoais.")),
                    react_1.default.createElement(antd_1.Form.Item, null,
                        react_1.default.createElement(antd_1.Button, { type: "primary", htmlType: "submit", className: "btn-register" }, "Criar conta")),
                    react_1.default.createElement("div", { className: "register-footer" },
                        react_1.default.createElement("div", { className: "row" },
                            react_1.default.createElement("span", null,
                                "J\u00E1 tem uma conta? \u00A0",
                                react_1.default.createElement("a", { onClick: () => history.push(RoutesPaths_1.routesPaths.login) }, "Entrar"))),
                        react_1.default.createElement("div", { className: "row" },
                            react_1.default.createElement("span", null,
                                "Ao fazer login ou criar uma conta, voc\u00EA concorda com as nossas condi\u00E7\u00F5es do \u00A0",
                                react_1.default.createElement("a", { onClick: () => { var _a; return (_a = showModalTermsRef.current) === null || _a === void 0 ? void 0 : _a.modalVisible(); } }, "termos de uso"),
                                "\u00A0 e \u00A0",
                                react_1.default.createElement("a", { onClick: () => { var _a; return (_a = showModalTermsRef.current) === null || _a === void 0 ? void 0 : _a.modalVisible(); } }, "pol\u00EDtica de privacidade."))))))),
        react_1.default.createElement(antd_1.Modal, { wrapClassName: "Register-wrap-modal", title: "", width: "600px", style: { top: 100 }, visible: !!registerData, onOk: () => setRegisterData(null), onCancel: () => setRegisterData(null), footer: [] },
            react_1.default.createElement("div", { className: "register-modal-title" }, "Deseja confirmar seu cadastro?"),
            react_1.default.createElement("div", { className: "register-modal-body" },
                react_1.default.createElement("div", { className: "confirm-container" },
                    react_1.default.createElement("div", { className: "confirm-row" },
                        react_1.default.createElement("div", { className: "confirm-label" }, "Nome:"),
                        react_1.default.createElement("div", { className: "confirm-value" }, registerData === null || registerData === void 0 ? void 0 : registerData.firstName)),
                    react_1.default.createElement("div", { className: "confirm-row" },
                        react_1.default.createElement("div", { className: "confirm-label" }, "Sobrenome:"),
                        react_1.default.createElement("div", { className: "confirm-value" }, registerData === null || registerData === void 0 ? void 0 : registerData.lastName)),
                    react_1.default.createElement("div", { className: "confirm-row" },
                        react_1.default.createElement("div", { className: "confirm-label" }, "E-mail:"),
                        react_1.default.createElement("div", { className: "confirm-value" }, registerData === null || registerData === void 0 ? void 0 : registerData.email)),
                    react_1.default.createElement("div", { className: "confirm-row" },
                        react_1.default.createElement("div", { className: "confirm-label" }, "Telefone:"),
                        react_1.default.createElement("div", { className: "confirm-value" },
                            "+ ", registerData === null || registerData === void 0 ? void 0 :
                            registerData.ddi,
                            "\u00A0",
                            (registerData === null || registerData === void 0 ? void 0 : registerData.ddi) === '55' ? (0, format_1.formatCellphone)((registerData === null || registerData === void 0 ? void 0 : registerData.telephone) || '') : registerData === null || registerData === void 0 ? void 0 : registerData.telephone)),
                    react_1.default.createElement("div", { className: "confirm-row" },
                        react_1.default.createElement("div", { className: "confirm-label" }, "Pa\u00EDs:"),
                        react_1.default.createElement("div", { className: "confirm-value" }, getCountryName((registerData === null || registerData === void 0 ? void 0 : registerData.country) || '')))),
                react_1.default.createElement(antd_1.Button, { className: "btn-confirm-cancel", onClick: () => setRegisterData(null) }, "Voltar"),
                react_1.default.createElement(antd_1.Button, { type: "primary", className: "btn-confirm", loading: isLoading, onClick: handleRequest }, "Confirmar")))));
};
exports.default = Register;
